import type {
  AspectRatio,
  Color,
  ContentfulCollection,
  ContentfulLink,
  ContentfulModule,
  ContentfulRichTextBlock,
  DocumentWithEmbeddedEntries,
  MediaAsset,
} from 'libs/contentful/types';
import type { CalloutColumns, CopyJustification, KeyLinePosition, Margins } from 'types/constants';

/**
 * Available variants for the CalloutGrid component
 * - Basic: Simple text-only cards
 * - Icon: Cards with icons and text
 * - Image: Cards with images and text
 */
export enum CalloutGridVariants {
  Basic = 'Basic',
  Icon = 'Icon',
  Image = 'Image',
}

export interface CalloutGridCardProps extends ContentfulModule {
  iconName?: string;
  image?: MediaAsset;
  aspectRatio?: AspectRatio;
  headline?: DocumentWithEmbeddedEntries;
  headlineSmallRte?: ContentfulRichTextBlock;
  copy?: DocumentWithEmbeddedEntries;
  attributionRte?: ContentfulRichTextBlock;
  link?: ContentfulLink;
}

export interface CalloutGridProps extends ContentfulModule {
  cards: ContentfulCollection<CalloutGridCardProps>;
  copyJustification?: CopyJustification;
  keyline?: KeyLinePosition;
  color: Color;
  margins: Margins;
  columns: CalloutColumns;
  variant: CalloutGridVariants;
}
